module.exports = __webpack_public_path__ + "static/media/dashboard.a72db975.jpg";